import { render, staticRenderFns } from "./BuyerDashboardCampaigns.vue?vue&type=template&id=78fd9805&scoped=true"
import script from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"
export * from "./BuyerDashboardCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fd9805",
  null
  
)

export default component.exports